import { Switch } from '@aloft/toolkit-sui';

export const AddToExportSwitch = ({
  id,
  value: isOmit,
  setValue: setIsOmit,
}: {
  id: string;
  value: boolean;
  setValue: (val: boolean) => void;
}) => {
  return (
    <Switch id={id} label="Add to export" value={!isOmit} onChange={(val) => setIsOmit(!val)} />
  );
};
